import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import createComplectation from '../../../api/cars/createComplectation';
import Form from '../../../components/Form/Form';
import Header from '../../../components/Header/Header';
import styles from '../../../components/Form/form.module.css';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import Checkbox from '../../../components/Inputs/Checkbox/Checkbox';
import icon from '../../../brand/generated/sidebar/cars.svg';
import { EQUIPMENT_VALUE_PLACEHOLDER, SAFETY_VALUE_PLACEHOLDER } from './optionPlaceholders';

const formStyles = {
  complectation: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr' },
};

const CarComplectationsCreate = () => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const makeKey = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

  const [complectation, setComplectation] = useState([
    { type: 'input', value: undefined, label: 'ID', placeholder: 'Укажите ID', inputType: 'number' },
    { type: 'input', value: undefined, label: 'Комплектация', placeholder: 'Укажите комплектацию' },
    { type: 'selectEngine', value: 1 },
    { type: 'selectCarcase', value: 1 },
    { type: 'selectWd', value: 2 },
    { type: 'input', label: 'Объем двигателя', value: undefined },
    { type: 'input', label: 'Л.С.', value: undefined },
    { type: 'input', label: 'Коробка передач', value: undefined },
    { type: 'input', label: 'Количество мест', value: undefined },
    { type: 'input', label: 'Поколение модели автомобиля', placeholder: 'Укажите поколение', value: undefined },
  ]);
  const [restyling, setRestyling] = useState(false);
  const [equipments, setEquipments] = useState([{ key: makeKey(), title: '', subtitle: '' }]);
  const [safety, setSafety] = useState([{ key: makeKey(), title: '', subtitle: '' }]);

  // Опция — пара «название — значение» («Датчики парковки» — «Задние»): так её
  // показывает карточка Halyk Market. Пустое значение не отправляем.
  const optionRows = (rows) =>
    rows.map(({ title, subtitle }) => ({ title, subtitle: (subtitle || '').trim() || undefined }));

  const createComplectationCar = () => {
    createComplectation({
      title: complectation[1].value,
      containerId: searchParams.get('id'),
      engineId: complectation[2].value,
      complectation_safely: optionRows(safety),
      complectation_equipment: optionRows(equipments),
      carcaseId: complectation[3].value,
      wdId: complectation[4].value,
      engine_volume: complectation[5].value,
      power_value: complectation[6].value,
      transmission: complectation[7].value,
      seats: complectation[8].value,
      generation: complectation[9].value,
      restyling: restyling,
    }).then(() => navigate('/cars/complectations'));
  };

  return (
    <>
      <Header title={'Новая комплектация'} icon={icon} />
      <div style={{ paddingBottom: '20px' }}>
        <Form
          inputs={complectation}
          title={'Комплектации'}
          grid={formStyles.complectation}
          action={'Сохранить'}
          showBtn={false}
          handlerSetState={setComplectation}
          handleSubmit={createComplectationCar}
          border
          footer={
            <Checkbox
              label="Признак рестайлинга модели автомобиля"
              id="restyling"
              value={restyling}
              onChange={() => setRestyling(!restyling)}
              style={{ marginTop: 20, marginBottom: 20, marginLeft: 20 }}
            />
          }
        />

        <div className={styles.borderWrapper}>
          <h1>Комфорт и Оборудование</h1>
          <br />
          {equipments.map((item, index) => (
            <div
              key={item.key}
              style={{ marginBottom: 15, display: 'grid', gridTemplateColumns: '1fr 2fr 55px', gap: 10, alignItems: 'end' }}
            >
              <Input
                label={'Название'}
                placeholder={'Введите значение'}
                value={item.title}
                onChange={(e) => {
                  equipments[index].title = e.target.value;
                  setEquipments([...equipments]);
                }}
              />
              <Input
                label={'Значение'}
                placeholder={EQUIPMENT_VALUE_PLACEHOLDER}
                value={item.subtitle}
                onChange={(e) => {
                  equipments[index].subtitle = e.target.value;
                  setEquipments([...equipments]);
                }}
              />
              {/* <Button
                style={{ marginLeft: 0, cursor: 'pointer' }}
                text={'X'}
                onClick={() => {
                  if (equipments.length === 1) {
                    setEquipments([{ key: makeKey(), title: '' }]);
                    return;
                  }
                  setEquipments(equipments.filter((i) => i.key !== item.key));
                }}
              /> */}
            </div>
          ))}
          <Button
            onClick={() => {
              equipments.push({ key: makeKey(), title: '', subtitle: '' });
              setEquipments([...equipments]);
            }}
            style={{
              marginTop: 15,
              marginBottom: 15,
            }}
            text={'Добавить'}
            fill
          />
          <h1>Безопасность</h1>
          {safety.map((item, index) => (
            <div
              key={item.key}
              style={{ marginBottom: 15, display: 'grid', gridTemplateColumns: '1fr 2fr 55px', gap: 10, alignItems: 'end' }}
            >
              <Input
                label={'Название'}
                placeholder={'Введите значение'}
                value={item.title}
                onChange={(e) => {
                  safety[index].title = e.target.value;
                  setSafety([...safety]);
                }}
              />
              <Input
                label={'Значение'}
                placeholder={SAFETY_VALUE_PLACEHOLDER}
                value={item.subtitle}
                onChange={(e) => {
                  safety[index].subtitle = e.target.value;
                  setSafety([...safety]);
                }}
              />
              {/* <Button
                style={{ marginLeft: 0, cursor: 'pointer' }}
                text={'X'}
                onClick={() => {
                  if (safety.length === 1) {
                    setSafety([{ key: makeKey(), title: '' }]);
                    return;
                  }
                  setSafety(safety.filter((i) => i.key !== item.key));
                }}
              /> */}
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={() => {
                safety.push({ key: makeKey(), title: '', subtitle: '' });
                setSafety([...safety]);
              }}
              style={{
                marginTop: 15,
                marginBottom: 15,
              }}
              text={'Добавить'}
              fill
            />
            <Button
              onClick={() => createComplectationCar()}
              style={{
                marginTop: 15,
                marginBottom: 15,
              }}
              text={'Сохранить'}
              fill
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CarComplectationsCreate;
